import {FaUsers} from "react-icons/fa";
import {InputTextCustom} from "../../components";
import {useContext, useRef, useState} from "react";
import {UserApi} from "../../apis";
import {useLocation, useNavigate} from "react-router";
import {LoadingContext, PageContext, ToastContext, UserContext} from "../../contexts";
import ImgDefault from "../../assets/img/no-image.png";
import {cpf as CPFLib} from "cpf-cnpj-validator";
import {cpfMask} from "../../envs/mask";

export const UserEdit = () => {
  const location = useLocation();
  const {user, setUser} = useContext(UserContext);
  const {pageInfo, setPageInfo} = useContext(PageContext);
  const {setLoading} = useContext(LoadingContext);
  const [count, setCount] = useState(0);
  const [funcao, setFuncao] = useState('Colaborador');
  const [loja, setLoja] = useState('Itabaiana');

  const [matricula, setMatricula] = useState('');

  const [nome, setNome] = useState('');
  const [helperNome, setHelperNome] = useState('');
  const [errorNome, setErrorNome] = useState(false);

  const [cpf, setCpf] = useState('');
  const [helperCpf, setHelperCpf] = useState('');
  const [errorCpf, setErrorCpf] = useState(false);

  const [imagem, setImagem] = useState(null);
  const [imagemForm, setImagemForm] = useState(null);

  const inputImgRef = useRef();

  const navigate = useNavigate();

  const toasts = useContext(ToastContext);
  const AddToast = (item) => {
    let tempArr = [...toasts.toast];
    tempArr.push(item);
    toasts.setToast({toast: tempArr, setToast: toasts.setToast});
  }

  const load = async () => {
    setLoading(true);
    try {
      let resultadoLoad = await UserApi.getUser(user.uuid, location.state.uuid);
      if (!resultadoLoad.error) {
        setLoading(false);
        setNome(resultadoLoad.data.nome);
        setCpf(resultadoLoad.data.cpf);
        setMatricula(resultadoLoad.data.matricula);
        setImagem(resultadoLoad.data.avatar);
        setFuncao(resultadoLoad.data.funcao);
        setLoja(resultadoLoad.data.loja);
      } else {
        navigate('/portalcolaborador/inicio');
        setLoading(false);
        AddToast({texto: resultadoLoad.error, tipo: "erro"});
      }
    } catch (e) {
      navigate('/portalcolaborador/inicio');
      setLoading(false);
      AddToast({texto: e, tipo: "erro"});
    }
  }

  if (count < 1) {
    if (location.state.uuid !== 0) {
      load();
    }
    setPageInfo(
      {
        ...pageInfo,
        titulo: 'Usuários',
        icone: <FaUsers size={30}/>
      }
    );
    setCount(count + 1);
  }

  const validarCampos = () => {
    setErrorNome(false);

    if (nome === "") {
      setHelperNome('O Campo não pode estar vazio');
      setErrorNome(true);
      return false;
    }

    if (cpf === "") {
      setHelperCpf("O Campo não pode estar vazio");
      setErrorCpf(true);
      return false;
    }

    if(!CPFLib.isValid(cpf)) {
      setHelperCpf("O CPF informado é inválido");
      setErrorCpf(true);
      return false;
    }

    return true;
  }

  const sendUser = async () => {
    setLoading(true);
    if (validarCampos()) {
      try {
        let resultadoUserSave;
        if (location.state.uuid !== 0) {
          resultadoUserSave = await UserApi.update(
            user.uuid,
            location.state.uuid,
            nome,
            cpf,
            matricula,
            imagemForm,
            funcao,
            loja
          );
        } else {
          resultadoUserSave = await UserApi.create(
            user.uuid,
            nome,
            cpf,
            matricula,
            imagemForm,
            funcao,
            loja
          );
        }

        if (!resultadoUserSave.error) {
          setLoading(false);
          if (location.state.uuid === user.uuid) {
            AddToast({texto: "Alterado!", tipo: "sucesso"});
            setUser(
              {
                uuid: null,
                nome: null,
                avatar: null,
                nivel: null,
                funcao: null,
                loja: null
              }
            );
            localStorage.clear();
            navigate('/portalcolaborador/login');
          } else {
            AddToast({texto: "Sucesso!", tipo: "sucesso"});
            navigate('/portalcolaborador/user');
          }
        } else {
          setLoading(false);
          AddToast({texto: resultadoUserSave.error, tipo: "erro"});
        }
      } catch (e) {
        AddToast({texto: e, tipo: "erro"});
        setLoading(false);
      }
    }
    setLoading(false);
  }

  const changeImage = (event) => {
    setImagem(URL.createObjectURL(event.target.files[0]));
    setImagemForm(event.target.files[0]);
  }

  return (
    <div className="user painel-itens">
      {location.state.uuid !== 0 ? <h2 className="titulo">Editar usuário</h2> : <h2 className="titulo">Novo usuário</h2>}
      <div className="form-usuario">
        <div className="input-img-box">
          <img onClick={() => {
            inputImgRef.current.click()
          }} className="user-avatar" src={imagem ? imagem : ImgDefault} alt={user.nome}/>
          <input
            ref={inputImgRef}
            className="input-img"
            accept="Image/*"
            type="file"
            onChange={(e) => changeImage(e)}/>

          <div className="btn btn-enviar" onClick={() => {inputImgRef.current.click()}}>
            <span>Alterar imagem</span>
          </div>

          {location.state.uuid !== 0 &&
            <div className="btn btn-primary" onClick={() => {
              navigate('/portalcolaborador/user/senha', {state: {uuid: location.state.uuid}})
            }}>
              <span>Alterar Senha</span>
            </div>
          }
        </div>

        <div className="user-fields">
          <InputTextCustom
            label="Nome"
            value={nome}
            onChange={(e) => setNome(e.target.value)}
            helperText={helperNome}
            error={errorNome}
          />

          {(user.nivel === 'admin' || user.nivel === 'sadmin') &&
            <InputTextCustom
              label="CPF"
              value={cpf}
              onChange={(e) => setCpf(cpfMask(e.target.value))}
              helperText={helperCpf}
              error={errorCpf}
            />
          }

          {user.nivel.includes('admin') &&
            <InputTextCustom
              label="Matrícula"
              value={matricula}
              onChange={(e) => setMatricula(e.target.value)}
            />
          }

          {(user.nivel === "admin" || user.nivel === 'sadmin') &&
            <div className="seletor">
              <label>Função:</label>
              <select onChange={(e) => {
                setFuncao(e.target.selectedOptions[0].label);
              }}>
                <option selected={funcao === "Colaborador"}>Colaborador</option>
                <option selected={funcao === "Departamento Pessoal"}>Departamento Pessoal</option>
                <option selected={funcao === "Líder"}>Líder</option>
                <option selected={funcao === "Recursos Humanos"}>Recursos Humanos</option>
                <option selected={funcao === "TI"}>TI</option>
              </select>
            </div>
          }

          {(user.nivel === "admin" || user.nivel === 'sadmin') &&
            <div className="seletor">
              <label>Loja:</label>
              <select onChange={(e) => {
                setLoja(e.target.selectedOptions[0].label);
              }}>
                <option selected={loja === "Itabaiana"}>Itabaiana</option>
                <option selected={loja === "Glória"}>Glória</option>
              </select>
            </div>
          }
        </div>
      </div>
      <div className="d-flex justify-end">
        <div className="btn btn-cancelar" onClick={() => navigate(-1)}>
          Cancelar
        </div>
        <div className="btn btn-enviar" onClick={sendUser}>
          Cadastrar
        </div>
      </div>
    </div>
  );
}